import { useState } from "react";
import { toast } from "sonner";
import { MapPin } from "lucide-react";
import { api, errorText, newRequestId } from "../../lib/api";
import { COMMUNES } from "../../data/services";

export function CoverageCheck() {
  const [f, setF] = useState({ nom: "", telephone: "", ville: "", adresse: "", service: "Pare-brise", consentement: false, website: "" });
  const [rid] = useState(newRequestId);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/leads", { ...f, type: "domicile", request_id: rid });
      setSent(true);
      toast.success("Merci ! Nous vérifions votre adresse et revenons vers vous.");
    } catch (err) {
      toast.error(errorText(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div id="verifier-adresse" className="mb-12 scroll-mt-28 rounded-[1.75rem] bg-ag-mist p-7 ring-1 ring-ag-blue/10 sm:p-10" data-testid="coverage-check">
      <h2 className="font-display text-3xl font-extrabold tracking-tight text-ag-ink">Vérifier si mon adresse est desservie</h2>
      <p className="mt-3 text-slate-700">Indiquez votre adresse : nous vous confirmons si une intervention à domicile est possible avant tout rendez-vous.</p>
      {sent ? (
        <p className="mt-6 rounded-2xl bg-white p-5 font-semibold text-ag-navy" data-testid="coverage-success">Demande reçue. Nous vous recontactons pendant nos horaires d'ouverture.</p>
      ) : (
        <form onSubmit={submit} className="mt-6 grid gap-3 sm:grid-cols-2" data-testid="coverage-form">
          <input className="field" placeholder="Nom *" required value={f.nom} onChange={set("nom")} aria-label="Nom" data-testid="coverage-name" />
          <input className="field" type="tel" placeholder="Téléphone *" required value={f.telephone} onChange={set("telephone")} aria-label="Téléphone" data-testid="coverage-phone" />
          <input className="field sm:col-span-2" placeholder="Adresse" value={f.adresse} onChange={set("adresse")} aria-label="Adresse" data-testid="coverage-address" />
          <input className="field" placeholder="Ville *" required value={f.ville} onChange={set("ville")} aria-label="Ville" data-testid="coverage-city" />
          <select className="field" value={f.service} onChange={set("service")} aria-label="Service" data-testid="coverage-service">
            {["Pare-brise", "Impact", "Vitrage automobile", "Autre"].map((o) => <option key={o}>{o}</option>)}
          </select>
          <input className="hidden" tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} aria-hidden="true" />
          <label className="flex items-start gap-2 text-xs text-slate-600 sm:col-span-2">
            <input type="checkbox" required checked={f.consentement} onChange={set("consentement")} className="mt-0.5" data-testid="coverage-consent" />
            J'accepte que mes données soient utilisées pour traiter ma demande.
          </label>
          <button disabled={busy} className="btn btn-blue justify-center sm:col-span-2 sm:justify-self-start" data-testid="coverage-submit">{busy ? "Envoi…" : "Vérifier mon adresse"}</button>
        </form>
      )}
      <div className="mt-8 border-t border-ag-blue/10 pt-6">
        <p className="text-sm font-semibold text-ag-ink">Quelques communes desservies par le centre de Haguenau :</p>
        <ul className="mt-3 flex flex-wrap gap-2" data-testid="communes-list">
          {COMMUNES.map((c) => <li key={c} className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1 text-sm text-slate-700 ring-1 ring-slate-200"><MapPin className="h-3 w-3 text-ag-blue" />{c}</li>)}
        </ul>
        <p className="mt-3 text-xs text-slate-500">La possibilité d'une intervention à domicile est confirmée au cas par cas, selon l'adresse et le type d'intervention.</p>
      </div>
    </div>
  );
}
